import { combineReducers } from 'redux';
import agentPortalReducer from './adminPortal.reducers';

const reducer = combineReducers(Object.assign({
    agentPortal: agentPortalReducer
}));

export default reducer;